import { Globe2, Target } from "lucide-react";
import { useLanguage } from "@/i18n";
import { Reveal, Chapter } from "./shared";

export const VisionMission = () => {
  const { t } = useLanguage();
  return (
    <section id="vision" className="scroll-mt-24 bg-paper" data-testid="vision-section">
      <div className="mx-auto max-w-7xl px-5 py-24 lg:px-10 lg:py-32">
        <Chapter num="02" label={t.vision.chapter.split("/ ")[1]} />
        <div className="mt-12 grid gap-6 lg:grid-cols-2">
          <Reveal>
            <div className="flex h-full flex-col justify-between rounded-[1.75rem] bg-brand-900 p-9 text-white sm:p-12" data-testid="vision-card">
              <div className="flex items-center gap-2 font-mono text-[11px] tracking-[0.3em] text-brand-400">
                <Globe2 size={14} /> {t.vision.visionLabel}
              </div>
              <p className="mt-14 font-display text-2xl font-bold leading-snug sm:text-3xl">{t.vision.vision}</p>
              <div className="mt-14 h-1 w-16 rounded-full bg-brand-500" />
            </div>
          </Reveal>
          <Reveal delay={0.12}>
            <div className="flex h-full flex-col justify-between rounded-[1.75rem] border border-neutral-200 bg-white p-9 sm:p-12" data-testid="mission-card">
              <div className="flex items-center gap-2 font-mono text-[11px] tracking-[0.3em] text-brand-700">
                <Target size={14} /> {t.vision.missionLabel}
              </div>
              <p className="mt-14 font-display text-2xl font-bold leading-snug text-neutral-900 sm:text-3xl">{t.vision.mission}</p>
              <div className="mt-14 h-1 w-16 rounded-full bg-neutral-900" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
